/* eslint-disable consistent-this */
import React, { PureComponent } from 'react';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';

import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import Video from '../../../../components/video';
import { Player } from 'ThreeTerminal_pc/video';
import { getVideoDetail, getVideoList } from '../../../../../services/api';

const RightFive = errorBoundary(
    class extends PureComponent {
        state = {
            videoIndex: 0,
            videoPlay: this.props.show,
            vConfig: {},
            list: [],
        };
        static propTypes = {
            content: PropTypes.array,
            show: PropTypes.bool,
        };
        UNSAFE_componentWillReceiveProps(nextProps) {
            console.log('nextProps==', nextProps);
            if (nextProps.show !== this.state.videoPlay) {
                this.setState({
                    videoPlay: nextProps.show,
                });
            }
        }
        async componentDidMount() {
            const index = this.state.videoIndex;
            const videos = this.props.content;
            const idString = this.videoArr(videos);

            const videoList = await getVideoList(idString);
            const guid = videos[index].guid;

            if (videoList.code === 0) {
                const newList = videoList.data;
                const first = newList.filter(item => item.guid === guid);

                this.setState({
                    list: newList,
                    vConfig: first[0],
                });
            } else {
                // 获取失败
            }
        }
        videoArr = ids => {
            let guids = '';

            // eslint-disable-next-line array-callback-return
            ids.map(item => {
                // guids.push(item.guid);
                guids += `${item.guid},`;
            });

            return guids;
        };
        changeVideo = index => {
            this.setState({
                videoPlay: false,
            });
            this.setState(
                {
                    videoIndex: index,
                },
                () => {
                    this.getNextVideo(index);
                },
            );
        };
        getNextVideo = async index => {
            const guid = this.props.content[index].guid;
            const newList = this.state.list;
            const video = newList.filter(item => item.guid === guid);

            this.setState({
                vConfig: video[0],
                videoPlay: true,
            });
        };

        render() {
            const { content, show } = this.props;
            const { videoIndex, videoPlay, vConfig } = this.state;
            const newList = content.map((item, index) => ({
                num: index,
                guid: item.guid,
                title: item.title,
            }));
            const videoSlide = newList.length > 3 ? [newList.slice(0, 3), newList.slice(3)] : newList;

            let _this = this;

            const sliderTmpl = function sliderTmpl(newContent) {
                const videoNum = _this.state.videoIndex;

                if (newContent && newContent.map) {
                    return newContent.map(
                        // eslint-disable-next-line no-confusing-arrow
                        (item, index) =>
                            item.num === videoNum ? (
                                <li
                                    name={item.guid}
                                    key={index}
                                    className={styles.current}
                                    onClick={_this.changeVideo.bind(_this, item.num)}>
                                    <a href="javascript:void(0);">
                                        <div>{item.title}</div>
                                    </a>
                                </li>
                            ) : (
                                <li name={item.guid} key={index} onClick={_this.changeVideo.bind(_this, item.num)}>
                                    <a href="javascript:void(0);">
                                        <div>{item.title}</div>
                                    </a>
                                </li>
                            ),
                    );
                } else {
                    return newContent.num === videoNum ? (
                        <li
                            name={newContent.guid}
                            className={styles.current}
                            onClick={_this.changeVideo.bind(_this, newContent.num)}>
                            <a href="javascript:void(0);">
                                <div>{newContent.title}</div>
                            </a>
                        </li>
                    ) : (
                        <li name={newContent.guid} onClick={_this.changeVideo.bind(_this, newContent.num)}>
                            <a href="javascript:void(0);">
                                <div>{newContent.title}</div>
                            </a>
                        </li>
                    );
                }
            };

            const config = {
                arrows: true,
                dots: false,
                // dotsAction: 'click',
                autoplay: false,
                unitSize: 864,
                extension: 2,
                dotCurrentStyle: styles.current,
                sliderTmpl,
            };
            const noScrollConfig = {
                arrows: true,
                dots: false,
                dotsAction: 'click',
                autoplay: false,
                autoplayInterval: 6000,
                speed: 1000,
                // dotStyle: styles.dot,
                dotCurrentStyle: styles.current,
                unitSize: 216,
                sliderTmpl,
            };
            const playermsg = {
                width: 778,
                height: 450,
                autoPlay: show,
                controls: true,
            };

            console.log('playermsg==', playermsg);

            return (
                <div style={{ display: show ? 'block' : 'none' }}>
                    <div className={styles.vedio}>
                        {videoPlay ? <Player videoConfig={vConfig} playermsg={playermsg} /> : ''}
                    </div>
                    <div className={styles.vedios_li}>
                        <div className={styles.vedio_container}>
                            <ul className={styles.playitem}>
                                <Slides config={newList.length > 3 ? config : noScrollConfig} content={videoSlide} />
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export { RightFive };
export default RightFive;
